import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';

import { Fields, reduxForm } from 'redux-form';

import OrdersTableRowItemStatusFields from 'components/workflow/OrdersTable/OrdersTableRowItemStatusFields';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

const styles = () => ({
  inputRoot: {
    padding: '2px 15px',
    boxSizing: 'border-box',
    width: '100%',
    borderRadius: 10,
    display: 'flex',
  },
  gridItemSecondary: {
    naxWidth: '20%',
    flexBasis: '20%',
  },
});

const PatientsFilterForm = ({
  handleSubmit, classes, namePrefix,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
  >
    <Fields
      names={[
        `${namePrefix}.Status Name`,
        `${namePrefix}.Status`,
      ]}
      namePrefix={namePrefix}
      // disabled={submitting}
      component={OrdersTableRowItemStatusFields}
    /> 
  </form>
);

PatientsFilterForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    inputRoot: PropTypes.string.isRequired,
  }).isRequired,
};

export default reduxForm({
  onSubmit: () => {},
})(withStyles(styles)(PatientsFilterForm));



// WEBPACK FOOTER //
// ./src/components/schedule/ScheduleCalendar/ScheduleCalendarItemStatusForm.js